import { IArrayResponse, IPaginatedResponse, IResponse, IUUIDResponse } from '../../response'
import { IOrderAccount, IWholesalerGMS } from '../wholesaler'
import { IOrder, IOrderRow } from '@cbgms/api/modules/order'
import { IVehicle, RMAReturnReason, RMAStatus, RMAType } from '@cbgms/api/modules'
import { RMAService } from '../enums/rma-service'

export interface IRma {
  ShopID: string
  CompanyUUID: string
  CreatedAt: string
  Status: RMAStatus
  UUID: string
  IsOffline: boolean
  ID: string
  WholesalerRef: string
  Lines: IRmaLine[]
}

export interface IRmaLine {
  ShopID: string
  OrderUUID: string
  ModifierType: string
  CompanyUUID: string
  OrderRowUUID: string
  UUID: string
  RMAUUID: string
  VehicleUUID: string
  WholesalerAccountUUID: string
  CreatedAt: string
  UpdatedAt: string
  Quantity: number
  Reason: string
  CustomReason: string
  Code: string
  SupplierArticleNumber: string
  Description: string
  Type: RMAType
  Brand: string
  BaseID: string
}

interface IRmaLineAxaptaReturn extends IRmaLine {
  ArticleNumber: string
}

export interface IRmaListResponse {
  Order: IOrder
  OrderAccount: IOrderAccount
  OrderRow: IOrderRow
  RMA: IRma
  RMALine: IRmaLine
  Wholesaler: IWholesalerGMS
  Vehicle: IVehicle
}

export interface IAxaptaReturnResponse {
  Order: IOrder
  OrderAccount: IOrderAccount
  OrderRow: IOrderRow
  RMA: IRma
  RMALine: IRmaLineAxaptaReturn
  Wholesaler: IWholesalerGMS
  Vehicle: IVehicle
}

export interface ICreateRmaRequest {
  Lines: ICreateRmaLine[]
}

export interface ICreateRmaLine {
  reason: RMAReturnReason
  quantity: number
  orderRowUUID: string
  customReason: string
}

export interface RmaOrderLine {
  CustomerOrderReference: string // maybe some enum
  Date: string
  ID: string
  IsBestMatch: boolean
  NetPrice: number
  TotalPrice: number
  OrderLineID: string
  ReturnableQuantity: number
  Brand: string
}

export interface RmaLine {
  OrderAccountUUID: string
  OrderLines: RmaOrderLine[]
  OrderRow: IOrderRow
  IsAutomatedOnlineRMA: boolean
}

export interface POSTRmaLine {
  OrderRowUUID: string
  OrderID: string
  OrderLineID: string
  Reason: RMAReturnReason
  CustomReason: string
  Quantity: number
}

export interface POSTRma {
  OrderAccountUUID: string
  Lines: POSTRmaLine[]
}

export interface POSTSupplierOrderRmaLine {
  OrderID: string
  OrderLineID: string
  Reason: RMAReturnReason
  CustomReason: string
  Quantity: number
  Description: string
  SupplierArticleNumber: string
  SupplierArticleIDType: string
  BaseID: string
  Brand: string
}

export interface POSTSupplierOrderRma {
  OrderAccountUUID: string
  Lines: POSTSupplierOrderRmaLine[]
}

export interface PUTRma {
  Status: RMAStatus
}

export interface RMASettings {
  OfflineRMA: OfflineRMASettings
}

export interface OfflineRMASettings {
  IsDefaultSetting: boolean
  IsEnabled: boolean
}

export interface RMAServiceOption {
  ServiceName: RMAService
  Description: string
  UnitsPerSale: number
  PricePerUnitWhenOrdered: number
  PriceSubtotalWhenOrdered: number
  SupplierArticleNumber: string
  SupplierArticleIDType: string
  CommercialName?: string
  DocumentId?: string
  Quantity?: number
}

export interface POSTRMAServiceOption {
  OrderAccountUUID: string
  Lines: RMAServiceOptionLine[]
  CustomerReturnOrderReference?: string
  CustomerReturnOrderEmail?: string
}

interface RMAServiceOptionLine {
  Description: string
  Quantity: number
  SupplierArticleNumber: string
  SupplierArticleIDType: string
}

export interface AxRma {
  UUID: string
  Id: string
  RMANumber: string
  RMAReference: string
  ReturnDate: string
  ArticleNumber: string
  ProductDescription: string
  Quantity: number
  NetPrice: number
  GrossPrice: number
  Currency: string
  UnitSellingPrice: number
  EanCode: string
  SupplierCatalogueNumber: string
  Brand: string
  RetailNetPrice: number
  TotalAmount: number
  TotalAmountInclVat: number
  TotalVatAmount: number
  RMAStatus: RMAStatus
}

export interface AxRmaListDetailedResponse {
  RMA: AxRma
}

export enum AxaptaReturnStatus {
  NotApproved = 'NotApproved',
  Approved = 'Approved',
  ReturnPrinted = 'ReturnPrinted'
}

export enum AxaptaReturnStatusERP {
  NotApproved = 'Not Approved',
  Approved = 'Approved',
  ReturnPrinted = 'Return printed'
}

export enum AxaptaReturnLineStatus {
  Awaiting = 'Awaiting',
  Registered = 'Registered',
  Quarantine = 'Quarantine',
  Received = 'Received',
  Invoiced = 'Invoiced',
  Cancelled = 'Cancelled'
}

export const getAxaptaReturnMapperdStatus = (status: AxaptaReturnStatusERP): AxaptaReturnStatus => {
  switch (status) {
    case AxaptaReturnStatusERP.NotApproved:
      return AxaptaReturnStatus.NotApproved
    case AxaptaReturnStatusERP.Approved:
      return AxaptaReturnStatus.Approved
    case AxaptaReturnStatusERP.ReturnPrinted:
      return AxaptaReturnStatus.ReturnPrinted
    default:
      return AxaptaReturnStatus.NotApproved
  }
}

export type POSTRmaResponse = IUUIDResponse
export type PUTRmaResponse = IUUIDResponse
export type GETRmaLinesResponse = IArrayResponse<RmaLine>
export type GETRmasResponse = IPaginatedResponse<IRmaListResponse>
export type GETRmaReasonsResponse = IArrayResponse<RMAReturnReason>
export type GETRmaDetailsResponse = IResponse<IRma>
export type GETRMASettingsResponse = IResponse<RMASettings>
export type GETRMAServiceOptionsResponse = IArrayResponse<RMAServiceOption>
